import { useState, useMemo } from 'react';

// La interfaz que ya definimos en page.tsx
interface SelectedEmployee {
  uuid: string;
  roleName?: string;
  permissions?: ReadonlyArray<string>;
}

// La interfaz del empleado que viene de la API
interface Employee {
  uuid: string;
  roleName?: string | null;
  permissions?: ReadonlyArray<string>;
}

export const useEmployeeSelection = (allEmployees: Employee[] = []) => {
  const [selectedEmployees, setSelectedEmployees] = useState<SelectedEmployee[]>([]);

  // Valores derivados y memorizados para optimizar re-renders
  const selectedIds = useMemo(() => selectedEmployees.map((e) => e.uuid), [selectedEmployees]);
  const selectedCount = useMemo(() => selectedEmployees.length, [selectedEmployees]);

  // Función para seleccionar/deseleccionar un empleado
  const toggleOne = (employee: Employee, checked: boolean) => {
    setSelectedEmployees((prev) =>
      checked
        ? [
            ...prev,
            {
              uuid: employee.uuid,
              roleName: employee.roleName ?? undefined,
              permissions: employee.permissions,
            },
          ]
        : prev.filter((e) => e.uuid !== employee.uuid),
    );
  };

  // Función para seleccionar/deseleccionar todos los empleados
  const toggleAll = (checked: boolean) => {
    setSelectedEmployees(
      checked
        ? allEmployees.map((employee) => ({
            uuid: employee.uuid,
            roleName: employee.roleName ?? undefined,
            permissions: employee.permissions,
          }))
        : [],
    );
  };

  // Función para limpiar la selección
  const clearSelection = () => {
    setSelectedEmployees([]);
  };

  return {
    selectedEmployees,
    selectedIds,
    selectedCount,
    toggleOne,
    toggleAll,
    clearSelection,
  };
};
